import { Circle, Image, Text, Transformer } from "react-konva";
import { useEffect, useRef, useState } from "react";

import useImage from "use-image";

const URLImage = ({
  image,
  isSelected,
  onSelect,
  onChange,
  onDragStart,
  selectedShape,
  onTransformEnd,
  onClickInfoBtn,
  stageRef,
  currentItem
}) => {
  // const navigate = useNavigate();
  const [img] = useImage(image.src);
  const shapeRef = useRef();
  const trRef = useRef();
  const minX = 0;
  const minY = 0;
  const maxX = stageRef.current.width();
  const maxY = stageRef.current.height();
  const [circleX, setCircleX] = useState();
  const [circleY, setCircleY] = useState();

  useEffect(() => {
    if (isSelected) {
      trRef?.current?.nodes([shapeRef.current]);
      trRef?.current?.getLayer().batchDraw();
    }
  }, [isSelected]);

  useEffect(() => {
    calcCircleX(selectedShape);
    calcCircleY(selectedShape);
  }, []);

  const calcCircleX = (shape) => {
    let scaleX = shape?.attrs?.scaleX / 2;
    const width = shape?.attrs?.image?.width || shape?.attrs?.width;
    const x = shape?.attrs?.x + width * scaleX + 20;
    setCircleX(x || -10);
  };

  const calcCircleY = (shape) => {
    const scaleY = shape?.attrs?.scaleY / 2 || 0.7;
    const height = shape?.attrs?.image?.height || shape?.attrs?.height;
    const y = shape?.attrs?.y - height * scaleY - 20;
    setCircleY(y || -10);
  };

  const hasNoData = !currentItem?.title || !currentItem?.description;

  return (
    <>
      <Image
        image={img}
        x={image.x}
        y={image.y}
        // I will use offset to set origin to the center of the image
        offsetX={img ? img.width / 2 : 0}
        offsetY={img ? img.height / 2 : 0}
        scaleX={image.scaleX}
        scaleY={image.scaleY}
        onClick={onSelect}
        onDragStart={onDragStart}
        onTap={onSelect}
        draggable
        ref={shapeRef}
        onDragEnd={(e) => {
          onChange({
            ...image,
            x: e.target.x(),
            y: e.target.y(),
          });
        }}
        onTransform={(e) => {
          calcCircleX(e?.target);
          calcCircleY(e?.target);
        }}
        onTransformEnd={(e) => {
          onChange({
            ...image,
            scaleX: e.target.scaleX(),
            scaleY: e.target.scaleY(),
            // x: e.target.x(),
            // y: e.target.y(),
          });
        }}
        onDragMove={(shape) => {
          const newX = shape.target.x();
          const newY = shape.target.y();
          calcCircleX(shape?.target);
          calcCircleY(shape?.target);
          if (newX < minX + trRef.current?.width() / 8) {
            // If not, revert to the initial position
            shape.target.x(minX + trRef.current?.width() / 8);
          }

          if (newX > maxX - trRef.current?.width() / 8) {
            // If not, revert to the initial position
            shape.target.x(
              stageRef.current.width() - trRef.current?.width() / 8
            );
          }

          if (newY < minY + trRef.current?.height() / 8) {
            // If not, revert to the initial position
            shape.target.y(minY + trRef.current?.height() / 8);
          }

          if (newY > maxY - trRef.current?.height() / 8) {
            // If not, revert to the initial position
            shape.target.y(
              stageRef.current.height() - trRef.current?.height() / 8
            );
          }
        }}
      />
      {selectedShape && (
        <>
          <Transformer
            anchorFill="info"
            anchorCornerRadius={10}
            anchorSize={10}
            keepRatio={false}
            ref={trRef}
            boundBoxFunc={(oldBox, newBox) => {
              // limit resize
              if (newBox.width < 5 || newBox.height < 5) {
                return oldBox;
              }
              return newBox;
            }}
            enabledAnchors={["top-right"]}
          />
          {!hasNoData &&
            <>
              <Circle
                x={circleX}
                y={circleY}
                radius={15}
                fill="#FFF"
                draggable={false}
                onClick={onClickInfoBtn}
                onMouseEnter={(e) => {
                  const stage = e.target.getStage();
                  stage.container().style.cursor = 'pointer';
                }}
                onMouseLeave={(e) => {
                  const stage = e.target.getStage();
                  stage.container().style.cursor = 'default';
                }}
              />
              <Text
                x={circleX - 3}
                y={circleY - 6}
                text="i"
                fillEnabled={true}
                fontSize={18}
                fill="#000"
                fontStyle="bold"
                draggable={false}
                onClick={onClickInfoBtn}
                onMouseEnter={(e) => {
                  const stage = e.target.getStage();
                  stage.container().style.cursor = 'pointer';
                }}
                onMouseLeave={(e) => {
                  const stage = e.target.getStage();
                  stage.container().style.cursor = 'default';
                }}
              />
            </>
          }
        </>
      )}
    </>
  );
};

export default URLImage;
